import { Container, Paper, Stack, Typography } from "@mui/material";

interface BackofficeAccessDeniedProps {
  duty: string;
}

export function BackofficeAccessDenied({ duty }: BackofficeAccessDeniedProps) {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
      <Paper
        component="section"
        variant="outlined"
        aria-label="Duty requirement"
        sx={{ p: { xs: 3, sm: 4 } }}
      >
        <Stack spacing={{ xs: 2, sm: 3 }}>
          <Typography component="h1" variant="h4">
            Access denied
          </Typography>
          <Typography sx={{ overflowWrap: "anywhere" }}>
            BOLON Backoffice requires the {duty} duty.
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
}
